import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import backgroundPattern from '../../assets/pasbookpng.png';
import "./Recurrencepage.css";

function CustomerPopup({ onClose, onCreate }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");
  const handleCreate = () => {
    if (!name.trim()) { setErr("Customer Name required"); setTimeout(()=>setErr(""),2000); return; }
    const newCust = { id: Date.now(), name, email, display_name: name };
    const all = JSON.parse(localStorage.getItem("customers") || "[]");
    localStorage.setItem("customers", JSON.stringify([...all, newCust]));
    onCreate(newCust);
    onClose();
  };
  return (
    <div className="rp-overlay" onClick={onClose}>
      <div className="rp-modal" onClick={e => e.stopPropagation()}>
        <div className="rp-modal-header"><h3>Add Customer</h3><span onClick={onClose} className="rp-close">×</span></div>
        <div className="rp-modal-body">
          <label>Customer Name *</label>
          <input className="rp-input" value={name} onChange={e => setName(e.target.value)} placeholder="Enter customer name" />
          <label>Email</label>
          <input className="rp-input" value={email} onChange={e => setEmail(e.target.value)} placeholder="customer@email.com" />
          {err && <div className="rp-inline-error">{err}</div>}
        </div>
        <div className="rp-modal-footer">
          <button className="rl-btn-primary" onClick={handleCreate}>Save Customer</button>
          <button className="rl-btn-secondary" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

export default function RecurrencePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state?.editData;

  const [customer, setCustomer] = useState(editData?.customer || "");
  const [profileName, setProfileName] = useState(editData?.profileName || "");
  const [orderNo, setOrderNo] = useState(editData?.orderNo || "");
  const [repeatEvery, setRepeatEvery] = useState(editData?.repeatEvery || "Week");
  const [startOn, setStartOn] = useState(editData?.startOn || "2026-08-26");
  const [endsOn, setEndsOn] = useState(editData?.endsOn || "");
  const [neverExpire, setNeverExpire] = useState(editData?!editData.endsOn : true);
  const [project, setProject] = useState(editData?.project || "");
  const [subject, setSubject] = useState(editData?.subject || "");
  const [adjustment, setAdjustment] = useState(editData?.adjustment || 0);
  const [taxType, setTaxType] = useState(editData?.taxType || "");
  const [customerNotes, setCustomerNotes] = useState(editData?.customerNotes || "Thanks for your business.");
  const [terms, setTerms] = useState(editData?.terms || "");
  const [salesperson, setSalesperson] = useState(editData?.salesperson || "");
  const [paymentTerms, setPaymentTerms] = useState(editData?.paymentTerms || "Due on Receipt");

  const [items, setItems] = useState(editData?.items || [{ id: 1, item: "", qty: 1, rate: 0, discount: 0 }]);
  const [showBulk, setShowBulk] = useState(false);
  const [selectedBulk, setSelectedBulk] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [toast, setToast] = useState(null);

  const [customerList, setCustomerList] = useState([]);
  const [showCustomerDrop, setShowCustomerDrop] = useState(false);
  const [custSearch, setCustSearch] = useState("");
  const [custLoading, setCustLoading] = useState(false);

  const [showSalesDrop, setShowSalesDrop] = useState(false);
  const [salesList, setSalesList] = useState(["John Doe", "Rahul Sharma", "Priya Singh"]);
  const [salesSearch, setSalesSearch] = useState("");
  const [showAddSales, setShowAddSales] = useState(false);
  const [newSales, setNewSales] = useState("");

  const [paymentList, setPaymentList] = useState(["Due on Receipt", "Net 15", "Net 30", "Net 45", "Due end of next month"]);
  const [showPaymentDrop, setShowPaymentDrop] = useState(false);
  const [paySearch, setPaySearch] = useState("");
  const [showAddPay, setShowAddPay] = useState(false);
  const [newPayTerm, setNewPayTerm] = useState("");

  // FIXED PROJECT DROPDOWN - now used
  const [projectList] = useState(["Website Redesign", "App Development", "Marketing Campaign", "Consulting"]);
  const [showProjectDrop, setShowProjectDrop] = useState(false);
  const [projectSearch, setProjectSearch] = useState("");

  const custRef = useRef(null);
  const salesRef = useRef(null);
  const payRef = useRef(null);
  const projRef = useRef(null);

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  useEffect(() => {
    const handler = (e) => {
      if (custRef.current &&!custRef.current.contains(e.target)) setShowCustomerDrop(false);
      if (salesRef.current &&!salesRef.current.contains(e.target)) setShowSalesDrop(false);
      if (payRef.current &&!payRef.current.contains(e.target)) setShowPaymentDrop(false);
      if (projRef.current &&!projRef.current.contains(e.target)) setShowProjectDrop(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    if (!showCustomerDrop) return;
    const local = JSON.parse(localStorage.getItem("customers") || "[]");
    const query = (custSearch || "").trim().toLowerCase();
    const normalized = local
      .map(c => ({ id: c.id, name: c.display_name || c.name || c.customer_name || "", email: c.email || "" }))
      .filter(c => c.name && (!query || c.name.toLowerCase().includes(query) || c.email.toLowerCase().includes(query)));
    setCustomerList(normalized);
    setCustLoading(false);
  }, [custSearch, showCustomerDrop]);

  const bulkItems = ["A1-₹0.00", "A3-₹0.00", "A4-₹0.00", "Oxygen-₹0.00", "Argon-₹0.00","Nitrogen-₹0.00","Carbon dioxide-₹0.00"];
  const filteredPay = paymentList.filter(p => p.toLowerCase().includes(paySearch.toLowerCase()));
  const filteredSales = salesList.filter(s => s.toLowerCase().includes(salesSearch.toLowerCase()));
  const filteredProjects = projectList.filter(p => p.toLowerCase().includes(projectSearch.toLowerCase()));

  const subTotal = items.reduce((s, i) => s + Number(i.qty || 0) * Number(i.rate || 0) * (1 - Number(i.discount || 0) / 100), 0);
  const taxAmount = taxType === "GST 18%"? subTotal * 0.18 : taxType === "GST 5%"? subTotal * 0.05 : 0;
  const total = subTotal + taxAmount + Number(adjustment || 0);

  const addRow = () => setItems([...items, { id: Date.now(), item: "", qty: 1, rate: 0, discount: 0 }]);
  const removeRow = (id) => {
    if (items.length === 1) { showToast("At least one row required", "error"); return; }
    setItems(items.filter(i => i.id!== id));
  };
  const updateItem = (id, field, val) => setItems(items.map(i => i.id === id? {...i, [field]: val } : i));
  const handleBulkAdd = () => {
    const newRows = selectedBulk.map(name => ({ id: Date.now() + Math.random(), item: name, qty: 1, rate: 100, discount: 0 }));
    setItems([...items,...newRows]); setShowBulk(false); setSelectedBulk([]); showToast(`${newRows.length} items added`);
  };

  const handleSave = () => {
    if (!customer.trim()) { showToast("Customer required", "error"); return; }
    if (!profileName.trim()) { showToast("Profile Name required", "error"); return; }
    const all = JSON.parse(localStorage.getItem("recurringInvoices") || "[]");
    const payload = { id: editData?.id || Date.now(), customer, salesperson, project, subject, profileName, orderNo, repeatEvery, startOn, endsOn: neverExpire? "" : endsOn, paymentTerms, items, subTotal, adjustment, taxType, total, customerNotes, terms, status: "Saved" };
    localStorage.setItem("recurringInvoices", JSON.stringify(editData? all.map(n => n.id === editData.id? payload : n) : [...all, payload]));
    showToast(editData? "Updated successfully" : "Recurring Invoice saved successfully");
    setTimeout(() => navigate("/dashboard/recurring-list"), 800);
  };

  const handleDraft = () => {
    const all = JSON.parse(localStorage.getItem("recurringInvoices") || "[]");
    const payload = { id: editData?.id || Date.now(), customer: customer || "Draft", salesperson, project, subject, profileName, orderNo, repeatEvery, startOn, endsOn: neverExpire? "" : endsOn, paymentTerms, items, subTotal, adjustment, taxType, total, customerNotes, terms, status: "Draft" };
    localStorage.setItem("recurringInvoices", JSON.stringify(editData? all.map(n => n.id === editData.id? payload : n) : [...all, payload]));
    showToast("Saved as Draft successfully", "info");
    setTimeout(() => navigate("/dashboard/recurring-list"), 800);
  };

  const confirmCancel = () => {
    setShowCancelConfirm(false);
    navigate("/dashboard/recurring-list");
  };

  const requestCancel = () => {
    setShowCancelConfirm(true);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key !== "Escape") return;
      if (showCancelConfirm) {
        setShowCancelConfirm(false);
      } else if (showBulk) {
        setShowBulk(false);
      } else {
        setShowCancelConfirm(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [showCancelConfirm, showBulk]);

  return (
    <div className="rp-page">
      <div
        className="rp-background-watermark"
        style={{ backgroundImage: `url(${backgroundPattern})` }}
      />
      {showPopup && <CustomerPopup onClose={() => setShowPopup(false)} onCreate={(c) => { setCustomer(c.name); setCustomerList(prev => [...prev, c]); }} />}

      <div className="rp-wrapper">
        <div className="rp-topbar">
          <h2><span className="icon-ref">↻</span> {editData? "Edit" : "New"} Recurring Invoice</h2>
          <button type="button" className="rp-top-close" onClick={requestCancel} aria-label="Back"><ArrowBack /></button>
        </div>

        <div className="rp-form-card">
          <div className="rp-details-grid">
          <div className="rp-row rp-span-2" ref={custRef}>
            <label className="rp-label req">Customer Name</label>
            <div className="rp-field">
              <div className="rp-cust-input-wrap">
                <div className="rp-select-box online" onClick={() => setShowCustomerDrop(!showCustomerDrop)}><span>{customer || "Select a customer"}</span></div>
                <span className="rp-inr">◉ INR</span>
              </div>
              {showCustomerDrop && (
                <div className="rp-dropdown">
                  <input className="rp-drop-search" placeholder="Search customer" value={custSearch} onChange={e => setCustSearch(e.target.value)} autoFocus />
                  <div className="rp-drop-list">
                    {custLoading && <div className="rp-drop-item muted">Searching...</div>}
                    {!custLoading && customerList.map((c, i) => (
                      <div key={c.id || i} className="rp-drop-item" onClick={() => { setCustomer(c.name); setShowCustomerDrop(false); setCustSearch(""); }}>
                        <b>{c.name}</b><br /><small>{c.email}</small>
                      </div>
                    ))}
                    {!custLoading && customerList.length === 0 && <div className="rp-drop-item muted">No customers found</div>}
                  </div>
                  <div className="rp-drop-foot"><span className="rp-add-link" onClick={() => { setShowCustomerDrop(false); setShowPopup(true); }}>+ Add Customer</span></div>
                </div>
              )}
            </div>
          </div>

          <div className="rp-row rp-span-2"><label className="rp-label req">Profile Name</label><div className="rp-field"><input className="rp-input" value={profileName} onChange={e => setProfileName(e.target.value)} placeholder="Profile Name" /></div></div>
          <div className="rp-row rp-span-2"><label className="rp-label">Order Number</label><div className="rp-field"><input className="rp-input" value={orderNo} onChange={e => setOrderNo(e.target.value)} /></div></div>
          <div className="rp-row"><label className="rp-label req">Repeat Every</label><div className="rp-field"><div className="rp-select-wrap"><select className="rp-input rp-small rp-select" value={repeatEvery} onChange={e => setRepeatEvery(e.target.value)}><option>Week</option><option>2 Weeks</option><option>Month</option><option>Year</option></select></div></div></div>
          <div className="rp-row rp-span-3"><label className="rp-label">Start On</label><div className="rp-field rp-flex"><input type="date" className="rp-input rp-date" value={startOn} onChange={e => setStartOn(e.target.value)} /><span className="rp-label-inline">Ends On</span><input type="date" className="rp-input rp-date" value={endsOn} disabled={neverExpire} onChange={e => setEndsOn(e.target.value)} /><label className="rp-checkbox"><input type="checkbox" checked={neverExpire} onChange={e => setNeverExpire(e.target.checked)} /> Never Expires</label></div></div>

          <div className="rp-row rp-span-2" ref={payRef}>
            <label className="rp-label">Payment Terms</label>
            <div className="rp-field">
              <div className="rp-select-box online w260" onClick={() => setShowPaymentDrop(!showPaymentDrop)}><span>{paymentTerms}</span></div>
              {showPaymentDrop && (
                <div className="rp-dropdown w260">
                  <input className="rp-drop-search" placeholder="Search" value={paySearch} onChange={e => setPaySearch(e.target.value)} />
                  <div className="rp-drop-list">{filteredPay.map(p => <div key={p} className="rp-drop-item" onClick={() => { setPaymentTerms(p); setShowPaymentDrop(false); }}>{p}</div>)}</div>
                  <div className="rp-drop-foot"><span className="rp-add-link" onClick={() => setShowAddPay(true)}>+ Add Payment Term</span></div>
                  {showAddPay && <div className="rp-add-inline"><input className="rp-input" placeholder="e.g. Net 60" value={newPayTerm} onChange={e => setNewPayTerm(e.target.value)} /><button className="rl-btn-primary small" onClick={() => { if (newPayTerm.trim()) { setPaymentList([...paymentList, newPayTerm]); setPaymentTerms(newPayTerm); setNewPayTerm(""); setShowAddPay(false); showToast("Payment term added"); } }}>Add</button></div>}
                </div>
              )}
            </div>
          </div>

          <div className="rp-row rp-span-2" ref={salesRef}>
            <label className="rp-label">Salesperson</label>
            <div className="rp-field">
              <div className="rp-select-box online" onClick={() => setShowSalesDrop(!showSalesDrop)}><span>{salesperson || "Select or Add Salesperson"}</span></div>
              {showSalesDrop && (
                <div className="rp-dropdown">
                  <input className="rp-drop-search" placeholder="Search salesperson" value={salesSearch} onChange={e => setSalesSearch(e.target.value)} />
                  <div className="rp-drop-list">{filteredSales.map(s => <div key={s} className="rp-drop-item" onClick={() => { setSalesperson(s); setShowSalesDrop(false); }}>{s}</div>)}</div>
                  <div className="rp-drop-foot"><span className="rp-add-link" onClick={() => setShowAddSales(true)}>+ Add Salesperson</span></div>
                  {showAddSales && (
                    <div className="rp-add-inline">
                      <input className="rp-input" placeholder="Add salesperson" value={newSales} onChange={e => setNewSales(e.target.value)} />
                      <button className="rl-btn-primary small" onClick={() => { if (newSales.trim()) { setSalesList([...salesList, newSales]); setSalesperson(newSales); setNewSales(""); setShowAddSales(false); showToast("Salesperson added successfully"); } }}>Add</button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="rp-row rp-span-2" ref={projRef}>
            <label className="rp-label">Associate Project(s)</label>
            <div className="rp-field">
              <div className="rp-select-box online" onClick={() => setShowProjectDrop(!showProjectDrop)}><span>{project || "Choose an existing project"}</span></div>
              {showProjectDrop && (
                <div className="rp-dropdown">
                  <input className="rp-drop-search" placeholder="Search project" value={projectSearch} onChange={e => setProjectSearch(e.target.value)} />
                  <div className="rp-drop-list">{filteredProjects.map(p => <div key={p} className="rp-drop-item" onClick={() => { setProject(p); setShowProjectDrop(false); }}>{p}</div>)}</div>
                  <div className="rp-drop-foot"><span className="rp-add-link muted">Project module coming soon</span></div>
                </div>
              )}
            </div>
          </div>

          <div className="rp-row rp-span-4"><label className="rp-label">Subject</label><div className="rp-field"><input className="rp-input" placeholder="Let your customer know what this Recurring Invoice is for" value={subject} onChange={e => setSubject(e.target.value)} /></div></div>

          </div>

          <div className="rp-section-title"><span>Item Table</span><button className="rp-bulk-btn" onClick={() => setShowBulk(true)}>◎ Bulk Actions</button></div>
          <div className="rp-table-wrap">
            <table className="rp-item-table">
              <thead><tr><th>ITEM DETAILS</th><th>QUANTITY</th><th>RATE</th><th>DISCOUNT</th><th>AMOUNT</th><th></th></tr></thead>
              <tbody>
                {items.map(r => (
                  <tr key={r.id}>
                    <td><input className="rp-cell-input" value={r.item} onChange={e => updateItem(r.id, "item", e.target.value)} placeholder="Type or click to select an item." /></td>
                    <td><input className="rp-cell-input center" type="number" value={r.qty} onChange={e => updateItem(r.id, "qty", e.target.value)} onWheel={(e) => e.target.blur()} /></td>
                    <td><input className="rp-cell-input right" type="number" value={r.rate} onChange={e => updateItem(r.id, "rate", e.target.value)} onWheel={(e) => e.target.blur()} /></td>
                    <td className="rp-discount-cell"><div className="rp-discount"><input className="rp-cell-input" type="number" value={r.discount} onChange={e=>updateItem(r.id,"discount",e.target.value)} onWheel={(e)=>e.target.blur()} /><span>%</span></div></td>
                    <td><div className="rp-amount">₹{(r.qty*r.rate*(1-(r.discount||0)/100)).toFixed(2)}</div></td>
                    <td><button className="rp-del-row" onClick={() => removeRow(r.id)}>×</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="rp-add-row-wrap"><button className="rp-add-row" onClick={addRow}>+ Add New Row</button><button className="rp-add-row" onClick={() => setShowBulk(true)}>+ Add Items in Bulk</button></div>

          <div className="rp-bottom">
            <div className="rp-notes"><label>Customer Notes</label><textarea value={customerNotes} onChange={e => setCustomerNotes(e.target.value)} /></div>
            <div className="rp-summary-box">
              <div className="rp-sum-row"><span>Sub Total</span><span>{subTotal.toFixed(2)}</span></div>
              <div className="rp-sum-row"><span>Tax</span><div className="rp-select-wrap small"><select className="rp-sum-select rp-select" value={taxType} onChange={e => setTaxType(e.target.value)}><option value="">Select a Tax</option><option>GST 18%</option><option>GST 5%</option></select></div><span>{taxAmount.toFixed(2)}</span></div>
              <div className="rp-sum-row"><span>Adjustment</span><input className="rp-sum-input" type="number" value={adjustment} onChange={e => setAdjustment(e.target.value)} onWheel={(e)=>e.target.blur()} /><span>{Number(adjustment).toFixed(2)}</span></div>
              <div className="rp-sum-row total"><span>Total ( ₹ )</span><span>{total.toFixed(2)}</span></div>
            </div>
          </div>

          <div className="rp-notes full"><label>Terms & Conditions</label><textarea value={terms} onChange={e => setTerms(e.target.value)} placeholder="Enter the terms and conditions of your business to be displayed in your transaction." /></div>

          <div className="rp-footer">
            <button className="rl-btn-primary" onClick={handleSave}>Save</button>
            <button className="rl-btn-draft" onClick={handleDraft}>Save as Draft</button>
            <button className="rl-btn-secondary" onClick={requestCancel}>Cancel</button>
          </div>
        </div>
      </div>

      {showBulk && (
        <div className="rp-overlay" onClick={() => setShowBulk(false)}>
          <div className="rp-modal bulk" onClick={e => e.stopPropagation()}>
            <div className="rp-modal-header"><h3>Add Items in Bulk</h3><span className="rp-close" onClick={() => setShowBulk(false)}>×</span></div>
            <div className="rp-modal-body">{bulkItems.map(name => <label key={name} className="rp-check"><input type="checkbox" checked={selectedBulk.includes(name)} onChange={e => { if (e.target.checked) setSelectedBulk([...selectedBulk, name]); else setSelectedBulk(selectedBulk.filter(x => x!== name)); }} /> {name}</label>)}</div>
            <div className="rp-modal-footer"><button className="rl-btn-primary" onClick={handleBulkAdd}>Add {selectedBulk.length} Items</button><button className="rl-btn-secondary" onClick={() => setShowBulk(false)}>Cancel</button></div>
          </div>
        </div>
      )}

      {toast && <div className={`rl-toast ${toast.type}`}><span className="rl-toast-dot"></span>{toast.msg}</div>}
      {showCancelConfirm && (
        <div className="rl-modal-overlay">
          <div className="rl-confirm-box"><div className="rl-confirm-icon">⚠️</div><h3>Discard changes?</h3><p>Your unsaved changes will be lost.</p><div className="rl-confirm-actions"><button className="rl-btn-secondary" onClick={() => setShowCancelConfirm(false)}>Keep Editing</button><button className="rl-btn-danger" onClick={confirmCancel}>Yes, Cancel</button></div></div>
        </div>
      )}
    </div>
  );
}